import {SearchParametersModel} from "../store/reducers/search";
import store from "../store/store";
import {WorkPackage} from "../models/responses/work-package.model";
import {ChecklistItemModel} from "../models/checklist-model";
import TaskModel from "../models/responses/task.model";

const filterChecklistItems = (
    checklistItem: ChecklistItemModel,
    searchParams: SearchParametersModel,
    workPackage?: WorkPackage,
    task?: TaskModel,
) => {
    if (!checklistItem) {
        return false;
    }
    if (!searchParams.chipList.length &&
        !searchParams.searchText &&
        !searchParams.taskForces.length &&
        !searchParams.startDate &&
        !searchParams.finishDate &&
        !searchParams.alert &&
        !searchParams.noTaskForce &&
        !searchParams.taskOwner &&
        !searchParams.workPackage &&
        !searchParams.function
    ) {
        return true;
    }
    let filtering = true;

    if (searchParams.workPackage && workPackage && searchParams.workPackage.workPackageId !== workPackage.workPackageId) {
        filtering = false;
    }

    if (searchParams.noTaskForce) {
        if (workPackage && workPackage.workPackageOwner) {
            const taskOwnerMember = store.getState().team.memberList
                // @ts-ignore
                .concat(store.getState().team.pendingMemberList)
                .find(member => member.userId === workPackage.workPackageOwner ||
                    member.userEmail === workPackage.workPackageOwner);
            if (taskOwnerMember && !taskOwnerMember.leftProject) {
                return false;
            }
        }
    }

    if (searchParams.alert) {
        if (checklistItem.due * 1000 > new Date().getTime()) {
            filtering = false;
        }
    }

    if (searchParams.chipList.length) {
        filtering = searchParams.chipList.every(
            (chip) => workPackage && (
                (workPackage.workPackageRef.toLowerCase().includes(chip.text.toLowerCase()) ||
                workPackage.workPackageName.toLowerCase().includes(chip.text.toLowerCase()) ||
                (workPackage.workPackageDescription &&
                    workPackage.workPackageDescription.toLowerCase().includes(chip.text.toLowerCase())))
                || (task && (task.task_code.toLowerCase().includes(chip.text.toLowerCase()) ||
                    task.task_name.toLowerCase().includes(chip.text.toLowerCase()) ||
                        task.wbsPath.toLowerCase().includes(chip.text.toLowerCase())
                ))
                || (checklistItem.itemName.toLowerCase().includes(chip.text.toLowerCase()))
            )
        );
    }

    if (searchParams.startDate || searchParams.finishDate) {
        if (searchParams.startDate) {
            if (searchParams.finishDate) {
                if (checklistItem.due > searchParams.finishDate || checklistItem.due < searchParams.startDate) {
                    filtering = false;
                }
            } else {
                if (checklistItem.due < searchParams.startDate) {
                    filtering = false;
                }
            }
        } else {
            if (checklistItem.due > searchParams.finishDate!) {
                filtering = false;
            }
        }
    }
    if (filtering && searchParams.searchText) {
        filtering = workPackage && (workPackage.workPackageRef.toLowerCase().includes(searchParams.searchText.toLowerCase()) ||
            workPackage.workPackageName.toLowerCase().includes(searchParams.searchText.toLowerCase()) ||
            (workPackage.workPackageDescription &&
                workPackage.workPackageDescription.toLowerCase().includes(searchParams.searchText.toLowerCase()))
        ) || (task && (task.task_code.toLowerCase().includes(searchParams.searchText.toLowerCase()) ||
            task.task_name.toLowerCase().includes(searchParams.searchText.toLowerCase()) ||
                task.wbsPath.toLowerCase().includes(searchParams.searchText.toLowerCase())
        )) || checklistItem.itemName.toLowerCase().includes(searchParams.searchText.toLowerCase());
    }
    if (filtering && searchParams.taskForces.length && searchParams.taskOwner.length) {
        if (workPackage && !workPackage.workPackageOwner && workPackage.workPackageTaskForce?.length === 0) {
            return false;
        }
        filtering = searchParams.taskForces.some((el) =>
            workPackage?.workPackageTaskForce?.includes(el[0]) || workPackage?.workPackageTaskForce?.includes(el[1])
        );
        filtering = filtering || workPackage?.workPackageOwner === searchParams.taskOwner[0] || workPackage?.workPackageOwner === searchParams.taskOwner[1];
        filtering = filtering || task?.taskOwner === searchParams.taskOwner[0] || task?.taskOwner === searchParams.taskOwner[1];
        filtering = filtering || !!(task && (task.taskForce.includes(searchParams.taskOwner[0]) || task.taskForce.includes(searchParams.taskOwner[1])));
    }
    else if (filtering && searchParams.taskForces.length) {
        if (workPackage?.workPackageTaskForce?.length === 0) {
            return false
        }
        filtering = searchParams.taskForces.some((el) =>
            workPackage?.workPackageTaskForce?.includes(el[0]) || workPackage?.workPackageTaskForce?.includes(el[1])
        );
    }
    else if (filtering && searchParams.taskOwner.length) {
        if (
            (!workPackage?.workPackageOwner || !(workPackage?.workPackageOwner === searchParams.taskOwner[0] || workPackage?.workPackageOwner === searchParams.taskOwner[1]))
            || (task?.taskOwner !== searchParams.taskOwner[0] && task?.taskOwner !== searchParams.taskOwner[1])
        ) {
            return false;
        }
    }

    if (searchParams.function && searchParams.function.functionId !== checklistItem.functionId) {
        filtering = false;
    }

    return filtering;
};

export default filterChecklistItems;
